import React from 'react';
import { Field } from 'formik';
import { observer } from 'mobx-react-lite';
import { Box, Chip, Typography } from '@mui/material';
import { PENDING } from 'constants/actions';
import { searchStore } from 'stores';
import { useTranslation } from 'hooks';
import Avatar from '../../Avatar';
import AsyncAutocompleteField from '../../Form/AsyncAutocompleteField';

const UserSearch = observer((props) => {
  const { users, usersFetchState } = searchStore;
  const { t } = useTranslation();

  const getOptions = (searchQuery) => {
    searchStore.getUsers({ query: searchQuery });
  };

  const renderUserAvatar = (option) => {
    return (
      <Avatar name={option.name} src={option.avatarUrl} alt={option.name} />
    );
  };

  return (
    <Field
      name="assignees"
      multiple
      component={AsyncAutocompleteField}
      getOptionLabel={(option) => option?.name ?? ''}
      options={users}
      loading={usersFetchState === PENDING}
      getOptions={getOptions}
      textFieldProps={{
        label: t('assignees'),
        margin: 'normal',
        ...props.textFieldProps,
      }}
      renderTags={(options, getTagProps) => {
        return options.map((option, index) => (
          <Chip
            key={option.id}
            label={option.name}
            avatar={renderUserAvatar(option)}
            {...getTagProps({ index })}
          />
        ));
      }}
      renderOption={(optionProps, option) => {
        return (
          <li {...optionProps}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ mr: 1 }}>{renderUserAvatar(option)}</Box>
              <Typography sx={{ color: 'black' }}>{option.name}</Typography>
            </Box>
          </li>
        );
      }}
    />
  );
});

export default UserSearch;
